import parameters from '@atlassian/jira-relay/src/__generated__/ui_IssueLinksPopUpContentQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = {
	issueKey: string;
	cloudId: string;
};

export const issueLinksPopUpContentEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-issue-links-content" */ './ui'),
	),
	getPreloadProps: ({ issueKey, cloudId }: EntryPointParams) => ({
		queries: {
			links: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					issueKey,
					cloudId,
				},
			},
		},
	}),
});
